import contextActionTypes from 'src/modules/shared/context/actionTypes';
import communityActionTypes from 'src/modules/community/shared/actionTypes';
import { navigateTo } from 'src/utils/router';
import Router from 'next/router';

import { close } from 'src/modules/websockets/initWebsockets';

export default () => next => action => {
  const result = next(action);
  switch (action.type) {
      case contextActionTypes.LOGOUT_SUCCESS:
        close();
        navigateTo('/');
        break;
      // TODO: do not refresh if not on community pages
      case communityActionTypes.FOLLOW_COMMUNITY_SUCCESS:
      case communityActionTypes.UNFOLLOW_COMMUNITY_SUCCESS:
         // reload current page to refresh page data
        Router.reload('/');
        break;
      case contextActionTypes.UPDATE_LANGUAGE_SUCCESS:
        // Reload the page
        window.scrollTo(0, 0);
        window.location.reload();
        break;
    default:
      break;
  }

  return result;
};



// WEBPACK FOOTER //
// ./src/middleware/router.js